const gSliderSections = document.querySelectorAll(".gentle-cellfab-slider");
gSliderSections.forEach((sliderSection, i) => {
  const slider = tns({
    container: sliderSection.querySelector(".slider"),
    items: 1,
    center: false,
    autoplay: false,
    controls: true,
    nav: false,
    //navContainer: sliderSection.querySelector('.team-slider-nav'),
    loop: true,
    autoplayButtonOutput: false,
    controlsContainer: sliderSection.querySelector(".slider-controls"),
    speed: 400,
    fixedWidth: 850,
    fixedHeight: 790,
    responsive: {
      1440: {
        fixedWidth: 850,
        gutter: 0,
      },
    },
  });
});
